import React, { useState } from "react";

export default function AddStockModal({ isOpen, onClose, onAddStock }) {
  const [formData, setFormData] = useState({
    sku: "",
    name: "",
    category: "Electronics",
    quantity: "",
    warehouse: "Main Warehouse",
    binLocation: "Bin-A1",
    unitPrice: "",
    supplier: "Global Tech Suppliers",
  });

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.quantity) return;
    onAddStock({
      id: Date.now(),
      sku: formData.sku || `SKU-${Math.floor(1000 + Math.random() * 9000)}`,
      name: formData.name,
      category: formData.category,
      quantity: parseInt(formData.quantity, 10) || 0,
      reorderLevel: 20,
      warehouse: formData.warehouse,
      binLocation: formData.binLocation,
      unitPrice: parseFloat(formData.unitPrice) || 50,
      status: parseInt(formData.quantity, 10) > 20 ? "Optimal" : "Low Stock",
      supplier: formData.supplier,
    });
    onClose();
  };

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content shadow-lg border-0 rounded-lg">
          <div className="modal-header bg-primary text-white py-3">
            <h5 className="modal-title font-weight-bold mb-0">
              <i className="fas fa-boxes mr-2"></i>Add New Inventory Stock
            </h5>
            <button
              type="button"
              className="close text-white opacity-100"
              onClick={onClose}
            >
              <span>&times;</span>
            </button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body p-4">
              <div className="form-row">
                <div className="form-group col-md-6">
                  <label className="font-weight-600">Product Name *</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="e.g. Wireless Ergonomic Mouse"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group col-md-6">
                  <label className="font-weight-600">SKU Code</label>
                  <input
                    type="text"
                    name="sku"
                    className="form-control"
                    placeholder="e.g. SKU-8849"
                    value={formData.sku}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group col-md-6">
                  <label className="font-weight-600">Category</label>
                  <select
                    name="category"
                    className="form-control"
                    value={formData.category}
                    onChange={handleChange}
                  >
                    <option value="Electronics">Electronics</option>
                    <option value="Hardware">Hardware</option>
                    <option value="Office Supplies">Office Supplies</option>
                    <option value="Raw Materials">Raw Materials</option>
                    <option value="Packaging">Packaging</option>
                  </select>
                </div>
                <div className="form-group col-md-6">
                  <label className="font-weight-600">Quantity *</label>
                  <input
                    type="number"
                    name="quantity"
                    className="form-control"
                    placeholder="e.g. 150"
                    min="1"
                    value={formData.quantity}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group col-md-6">
                  <label className="font-weight-600">Warehouse Location</label>
                  <select
                    name="warehouse"
                    className="form-control"
                    value={formData.warehouse}
                    onChange={handleChange}
                  >
                    <option value="Main Warehouse">Main Warehouse</option>
                    <option value="East Coast Depot">East Coast Depot</option>
                    <option value="West Coast Hub">West Coast Hub</option>
                    <option value="Central Storage">Central Storage</option>
                  </select>
                </div>
                <div className="form-group col-md-6">
                  <label className="font-weight-600">Bin Location (WMS)</label>
                  <input
                    type="text"
                    name="binLocation"
                    className="form-control"
                    placeholder="e.g. Bin-A12"
                    value={formData.binLocation}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group col-md-6">
                  <label className="font-weight-600">Unit Price ($)</label>
                  <input
                    type="number"
                    step="0.01"
                    name="unitPrice"
                    className="form-control"
                    placeholder="e.g. 45.00"
                    value={formData.unitPrice}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label className="font-weight-600">Supplier Name</label>
                  <input
                    type="text"
                    name="supplier"
                    className="form-control"
                    placeholder="e.g. Global Tech Supplies"
                    value={formData.supplier}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer bg-light px-4 py-3">
              <button
                type="button"
                className="btn btn-secondary px-4"
                onClick={onClose}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary px-4">
                <i className="fas fa-check mr-2"></i>Add Stock
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
